module.exports = __webpack_public_path__ + "img/qualityGreen.26cab6c1.png";